import React from 'react';
import moment from 'moment-timezone';
import InfoMessage from '@modules/common/components/banners/InfoMessage';
import TargetBlankLink from '@src/components/common/TargetBlankLink';

const COUNTDOWN_DATE = moment('2026-02-19');
const DEPRECATION_DATE = moment('2026-03-20');

const sunsetLink =
  'https://community.planet.com/product-updates/important-update-sunset-of-eo-browser-and-sentinel-hub-dashboard-6426';
const pipLink = 'http://insights.planet.com/';

function PIPBanner() {
  const isCountdownActive = moment().isAfter(COUNTDOWN_DATE);
  const diff = DEPRECATION_DATE.diff(moment(), 'days');
  const daysLeftText = isCountdownActive && diff >= 0 ? `in ${diff} days ` : '';

  return (
    <div style={{ margin: '1rem' }}>
      <InfoMessage
        icon="bell outline"
        header="Important update"
        content={
          <>
            The Sentinel Hub Dashboard is being deprecated {daysLeftText} on March 20, 2026. Please
            move your workflows to the new and improved Planet Insights Platform.{' '}
            <TargetBlankLink href={sunsetLink}>Read about the update here.</TargetBlankLink>
            <br />
            <TargetBlankLink href={pipLink} style={{ fontWeight: 'bold' }}>
              Open new experience
            </TargetBlankLink>
          </>
        }
      />
    </div>
  );
}

export default PIPBanner;
